import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class RouteTrackingService {
	private previousRoute: string = '';
	private currentUrl: string;

	constructor(private router: Router) {
		this.currentUrl = this.router.url;
		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.previousRoute = this.currentUrl;
				this.currentUrl = event.url;
				if (
					localStorage.getItem('previousRoute') == undefined ||
					localStorage.getItem('previousRoute') == null
				) {
					localStorage.setItem('previousRoute', this.previousRoute);
				} else if (this.previousRoute.length > 1) {
					localStorage.setItem('previousRoute', this.previousRoute);
				}
			}
		});
	}
}
